import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-right.svg';
import { ReactComponent as FacebookIcon } from 'assets/icons/facebook.svg';
import { ReactComponent as InstagramIcon } from 'assets/icons/instagram.svg';
import { ReactComponent as LinkedinIcon } from 'assets/icons/linkedin.svg';
import { ReactComponent as TwitterIcon } from 'assets/icons/twitter.svg';
import { ReactComponent as LogoImg } from 'assets/images/logo.svg';
import ChangeLanguage from 'components/common/change-language';
import { Spinner } from 'components/common/spinner';
import { paths } from 'lib/constants/paths';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiPhone } from 'react-icons/fi';
import { IoMailOpenOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { usePostApiV1ClientContactsCallMeMutation } from 'service/api/allApis';
import { toast } from 'sonner';

const Footer = () => {
    const [contactWithNumber, setContactWithNumber] = useState('');
    const [contactWithEmail, setContactWithEmail] = useState('');
    const [mutate, { isLoading }] = usePostApiV1ClientContactsCallMeMutation();
    const { t } = useTranslation();

    function handleContactWithNumberFormSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        mutate({
            darxApplicationDtOsContactsDtoCallMeRequestDto: {
                phoneOrEmailAdress: contactWithNumber,
            },
        })
            .unwrap()
            .then(() => {
                setContactWithNumber('');
                toast.success(t('footer.information-sent'));
            });
    }
    function handleContactWithEmailFormSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        mutate({
            darxApplicationDtOsContactsDtoCallMeRequestDto: {
                phoneOrEmailAdress: contactWithEmail,
            },
        })
            .unwrap()
            .then(() => {
                setContactWithEmail('');
                toast.success(t('footer.information-sent'));
            });
    }

    return (
        <footer
            id="footer"
            className="mt-20 hidden md:block w-full bg-brend-05 md:py-[35px] lg:py-[50px]"
        >
            <div className="md:w-[912px] lg:w-[1286px] mx-auto py-10 md:px-[48px] lg:px-[92px] border-[3px] border-txt-60 flex justify-between items-center z-[1] relative">
                <div className="w-[484px]">
                    <LogoImg className="fill-brend" />
                    <form onSubmit={handleContactWithNumberFormSubmit} className="mt-5 w-[416px]">
                        <label
                            className="flex mb-3 text-txt-60 font-medium text-[15px]"
                            htmlFor="footer-contact-with-number"
                        >
                            {t('footer.we-call-you')}
                        </label>
                        <div className="flex gap-x-4">
                            <input
                                onChange={(e) => setContactWithNumber(e.target.value)}
                                value={contactWithNumber}
                                id="footer-contact-with-number"
                                type="text"
                                className="px-4 py-3 border border-txt-60 rounded-[5px] text-[15px] w-full placeholder:text-txt-40 placeholder:font-medium hover:border-brend focus:border-primary focus:hover:border-primary outline-none duration-100"
                                placeholder="Nömrənizi qeyd edin"
                            />
                            <button
                                disabled={isLoading}
                                className="flex items-center justify-center px-4 py-3 text-txt-60 border border-txt-60 rounded-[5px] text-[15px]  hover:bg-primary disabled:hover:!bg-transparent hover:text-white disabled:hover:text-txt-60 duration-100"
                            >
                                {isLoading && <Spinner size={12} color="#B1924C" />}
                                {t('footer.verify')}
                            </button>
                        </div>
                    </form>
                    <form onSubmit={handleContactWithEmailFormSubmit} className="mt-5 w-[416px]">
                        <label
                            className="flex mb-3 text-txt-60 font-medium text-[15px]"
                            htmlFor="footer-contact-with-email"
                        >
                            {t('footer.get-emails')}
                        </label>
                        <div className="flex gap-x-4">
                            <input
                                onChange={(e) => setContactWithEmail(e.target.value)}
                                value={contactWithEmail}
                                id="footer-contact-with-email"
                                type="text"
                                className="px-4 py-3 border border-txt-60 rounded-[5px] text-[15px] w-full placeholder:text-txt-40 placeholder:font-medium hover:border-brend focus:border-primary focus:hover:border-primary outline-none duration-100"
                                placeholder="E-mail daxil edin"
                            />
                            <button className="flex items-center justify-center px-4 py-3 text-txt-60 border border-txt-60 rounded-[5px] text-[15px] hover:bg-primary hover:text-white disabled:hover:text-txt-60 duration-100 disabled:hover:!bg-transparent">
                                {isLoading && <Spinner size={12} color="#B1924C" />}
                                {t('footer.verify')}
                            </button>
                        </div>
                    </form>
                    <p className="mt-5 text-xs font-medium text-txt-60">{t('footer.terms')}</p>
                </div>
                <div className="flex gap-x-4 lg:gap-x-10">
                    <div>
                        <ul className="flex flex-col gap-y-2 text-base leading-[19px]">
                            <Link to={paths.advert.list}>
                                <li className="cursor-pointer duration-100 hover:text-txt-40 flex gap-x-2.5 items-center text-txt-60 font-medium">
                                    <ArrowIcon />
                                    {t('footer.ads')}
                                </li>
                            </Link>

                            <Link to={paths.agencies.list}>
                                <li className="cursor-pointer duration-100 hover:text-txt-40 flex gap-x-2.5 items-center text-txt-60 font-medium">
                                    <ArrowIcon />
                                    {t('footer.agencies')}
                                </li>
                            </Link>
                            <Link to={paths.residentialComplexes.list}>
                                <li className="cursor-pointer duration-100 hover:text-txt-40 flex gap-x-2.5 items-center text-txt-60 font-medium">
                                    <ArrowIcon />
                                    {t('footer.residental-complexes')}
                                </li>
                            </Link>
                            <Link to={paths.news.list}>
                                <li className="cursor-pointer duration-100 hover:text-txt-40 flex gap-x-2.5 items-center text-txt-60 font-medium">
                                    <ArrowIcon />
                                    {t('general.news')}
                                </li>
                            </Link>
                        </ul>
                    </div>
                    <div>
                        <h4 className="mb-[30px] text-xl font-bold text-txt-60">
                            {t('footer.follow-us')}
                        </h4>
                        <ul className="flex flex-col gap-y-5 text-[15px]">
                            <Link to="/">
                                <li className="cursor-pointer duration-100 hover:text-txt-40 flex gap-x-2.5 items-center text-txt-60 font-medium">
                                    <FacebookIcon />
                                    Facebook
                                </li>
                            </Link>
                            <Link to="/">
                                <li className="cursor-pointer duration-100 hover:text-txt-40 flex gap-x-2.5 items-center text-txt-60 font-medium">
                                    <InstagramIcon />
                                    Instagram
                                </li>
                            </Link>
                            <Link to="/">
                                <li className="cursor-pointer duration-100 hover:text-txt-40 flex gap-x-2.5 items-center text-txt-60 font-medium">
                                    <TwitterIcon />
                                    Twitter
                                </li>
                            </Link>
                            <Link to="/">
                                <li className="cursor-pointer duration-100 hover:text-txt-40 flex gap-x-2.5 items-center text-txt-60 font-medium">
                                    <LinkedinIcon />
                                    Linkedin
                                </li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="md:w-[912px] lg:w-[1286px] mx-auto mt-6 relative z-10 hidden md:flex text-txt-60 h-9 items-center justify-between  text-xs">
                <div className="flex">
                    <p className="flex items-center gap-x-2 w-[180px]">
                        <FiPhone />
                        <a href="tel:+994553087001">994(55) 308-70-01</a>
                    </p>
                    <p className="flex items-center gap-x-2 w-[150px]">
                        <FiPhone />
                        <a href="tel:+994993087001">994(99) 308-70-01</a>
                    </p>
                </div>
                <div className="flex items-center md:gap-x-8 lg:gap-x-[70px]">
                    <p className="flex items-center justify-end gap-x-2 w-[100px]">
                        <IoMailOpenOutline className="w-4 h-4" />
                        <a href="mailto:info@darxx.az">info@darxx.az</a>
                    </p>
                    <div className="flex items-center md:gap-x-8 ">
                        <ChangeLanguage color="brend" />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
